module.exports = {
    "breadcrumbs": `Navigointilinkit`
};


//# sourceMappingURL=fi-FI.main.js.map
